import { defineComponent as _defineComponent } from 'vue';
import { trans, transChoice } from 'laravel-vue-i18n';
import Button from 'primevue/button';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import DetailValue from '../../../../Components/DetailValue.vue';
import { useMitt } from '../../../../Plugins/mitt';
import { concatPlotsCodes, formatISODate } from '../../../../Services/Utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Details',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const emitter = useMitt();
        const numericFields = [
            { field: 'nitrogen', unit: 'kg/ha', label: '' },
            { field: 'phosphorus', unit: 'kg/ha', label: '' },
            { field: 'potassium', unit: 'kg/ha', label: '' },
            { field: 'calcium', unit: 'kg/ha', label: '' },
            { field: 'magnesium', unit: 'kg/ha', label: '' },
            { field: 'sulfur', unit: 'kg/ha', label: '' },
            { field: 'iron', unit: 'kg/ha', label: '' },
            { field: 'manganese', unit: 'kg/ha', label: '' },
            { field: 'zinc', unit: 'kg/ha', label: '' },
            { field: 'copper', unit: 'kg/ha', label: '' },
            { field: 'boron', unit: 'kg/ha', label: '' },
        ];
        numericFields.map((nf) => {
            nf.label = trans('labels.' + nf.field);
        });
        numericFields.sort((a, b) => a.label.localeCompare(b.label));
        const edit = () => emitter.emit('open-fertilization-form', props.data);
        emitter.on('fertilization-saved', (data) => Object.assign(props.data, data));
        const getRate = (field) => {
            const rate = Math.round(props.data[field] / props.data.fertilizer_quantity * 100);
            return rate > 0 ? rate + ' %' : '-';
        };
        const __returned__ = { emitter, props, numericFields, edit, getRate, get trans() { return trans; }, get transChoice() { return transChoice; }, get Button() { return Button; }, get Column() { return Column; }, get DataTable() { return DataTable; }, DetailValue, get concatPlotsCodes() { return concatPlotsCodes; }, get formatISODate() { return formatISODate; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
